import React from "react";
import { darkTheme } from "@yleisradio/yds-core";
import { ChevronLeft } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import { useEmbedParametersContext } from "../../contexts/embedParametersContext";
import i18n, { TranslationKey } from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { fontFamily } from "../../styles/global";
import { focusColor } from "../../styles/variables";
import { SettingHeader } from "../settings/styles";

const MenuHeaderContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;

const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  pointer-events: auto;

  span {
    display: flex;
    font-style: normal;
    line-height: 21px;
    ${fontFamily}
  }

  &:focus-visible {
    outline: 1px solid ${focusColor} !important;
  }
`;

const BackButton = styled(Button)<{ isMobile: boolean }>`
  color: ${({ isMobile }) =>
    isMobile ? darkTheme.ACTION_SECONDARY : darkTheme.ACTION_PRIMARY};
  height: 21px;
  margin-right: 24px;
  width: 8px;
`;

export const MenuHeader = ({
  backToTopLevel,
  label
}: {
  backToTopLevel: () => void;
  label: TranslationKey;
}) => {
  const { useStoreState } = usePlayerStore();
  const device = useStoreState.device();
  const uiSize = useStoreState.uiSize();

  const { language } = useEmbedParametersContext();

  return (
    <MenuHeaderContainer>
      <BackButton
        aria-label={i18n("palaa_edelliseen_valikkoon", { language })}
        isMobile={device.isMobile}
        onClick={backToTopLevel}>
        <ChevronLeft height={21} />
      </BackButton>
      <SettingHeader onClick={backToTopLevel} uiSize={uiSize}>
        {i18n(label, { language })}
      </SettingHeader>
    </MenuHeaderContainer>
  );
};
